export default "__VITE_ASSET__Dvs_8zcp__"